import React, { useEffect, useState } from 'react';
import "./authentication.css";
import Countries from "../Data/Countries.json";
import { Link, useNavigate } from 'react-router-dom';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { LoginAPI } from '../../Service/API/Post';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../Service/Redux/AuthContext';
import { BookingHoteDetailAndImagesAPI, GetProfileDetailAPI, GetUserWalletAPI } from '../../Service/API/Get';


export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('+91');
  const [formData, setFormData] = useState({
    countryCode: '91',
    phoneNo: '',
    password: '',
  });

  const [error, setError] = useState({
    phoneNo: '',
    password: '',
  });

  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setCountries(Countries);
  }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'phoneNo') {
      const phoneValue = value.replace(/\D/g, '');
      setFormData({
        ...formData,
        [name]: phoneValue,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name === 'phoneNo' && value) {
      setError(prevError => ({ ...prevError, phoneNo: '' }));
    }
    if (name === 'password' && value) {
      setError(prevError => ({ ...prevError, password: '' }));
    }
  };

  const handleCountryChange = (event) => {
    const countryCode = event.target.value;
    setSelectedCountry(countryCode);
    setFormData({
      ...formData,
      countryCode: countryCode.replace('+', '')
    });
  };
  
console.log("selected country from login>>",selectedCountry)
  const handleSubmit = async (event) => {
    console.log("login form data>>",formData)
    event.preventDefault();
    try {
      const res = await LoginAPI(formData);
      if (res.status === 200) {
        toast.success(res?.data?.message || 'Login Success!');
        login(res.data.token);
        // navigate("/booking");
      } else {
        setError({
          phoneNo: res.response.data.errors.phoneNo || '',
          password: res.response.data.errors.password || '',
        });
      }
    } catch (error) {
      console.log("error", error.message)
    }
  };

  return (
    <>
      <div className='login_outer'>
      <ToastContainer />
        <div className='container'>
          <div className='login_container'>
            <div className='login_head'>
              <div className='login_content_heading'>
                <h3>Login</h3>
                <p>For security, please login to access your information</p>
              </div>
              <div className='login_heading_button'>
                <Link to="/home" className='login_back_navigation_btn'>Back Home</Link>
              </div>
            </div>
            <div className='login_border_bottom'></div>
            <div className='login_form_area'>
              <form onSubmit={handleSubmit}>
                <div className='login_country_area'>
                  <label htmlFor='countryCode'>Country</label>
                  <select
                    name="countryCode"
                    className='login_country_input'
                    value={selectedCountry}
                    onChange={handleCountryChange}
                  >
                    <option value="">Select Country</option>
                    {countries.map((country, index) => (
                      <option key={index} value={country.code}>
                        {country.name} ({country.code})
                      </option>
                    ))}
                  </select>
                </div>
                <div className='login_mobile_area input_outer'>
                  <label htmlFor='phoneNo'>Mobile Number</label>
                  <input
                    type='text'
                    name="phoneNo"
                    className='login_mobile_input'
                    placeholder='Enter your Mobile number'
                    value={formData.phoneNo}
                    onChange={handleChange}
                  />
                  {error.phoneNo && <p className="error-message">{error.phoneNo}</p>}
                </div>
                <div className='login_password_area input_outer'>
                  <label htmlFor='password'>Password</label>
                  <div className="password-field">
                    <input
                      type={showPassword ? 'text' : 'password'}
                      name="password"
                      className='login_password_input'
                      placeholder='Enter your Password'
                      value={formData.password}
                      onChange={handleChange}
                    />
                    <span
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </span>
                  </div>
                  {error.password && <p className="error-message">{error.password}</p>}
                </div>

                <div className='login_btn_area'>
                  <input
                    type='submit'
                    value='LOGIN'
                    className='login_submit_btn'
                  />
                </div>
                <div className='login_already_account_area'>
                  <p>Not yet registered? <Link to="/register" className='registe_login_link'>Create An Account</Link></p>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
